<div class="modal-header border-0 pb-0">
  <h5 class="modal-title fw-bold centros-logisticos-cemento-modal-title">{{ modalTitle }}</h5>
  <button type="button" class="btn-close" aria-label="Cerrar" (click)="onClose()"></button>
</div>

<form [formGroup]="form" (ngSubmit)="onSave()">
  <div class="modal-body pt-2 pb-1 centros-logisticos-cemento-modal-body">
    <p class="centros-logisticos-cemento-modal-leyenda small text-muted mb-2">* Campos obligatorios</p>
    <div class="row g-3">
      <div class="col-md-6">
        <app-cbb-field
          label="Puesto de exploración *"
          formControlName="puestoExploracion"
          [mensajeError]="fieldError('puestoExploracion')"
        ></app-cbb-field>
      </div>
      <div class="col-md-6">
        <app-cbb-field
          label="Centro *"
          formControlName="centro"
          [mensajeError]="fieldError('centro')"
        ></app-cbb-field>
      </div>
      <div class="col-12">
        <app-cbb-field
          label="Centro nombre *"
          formControlName="centroNombre"
          [mensajeError]="fieldError('centroNombre')"
        ></app-cbb-field>
      </div>
      <div class="col-md-6">
        <app-cbb-field
          label="Planta *"
          formControlName="planta"
          [mensajeError]="fieldError('planta')"
        ></app-cbb-field>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0 pt-2 d-flex justify-content-evenly flex-wrap gap-2">
    <app-cbb-button
      *ngIf="isEditMode"
      label="Desactivar"
      color="primary"
      (action)="onDelete()"
      [disabled]="loading"
    ></app-cbb-button>
    <app-cbb-button
      [label]="isEditMode ? 'Guardar' : 'Crear'"
      color="green"
      type="submit"
      [disabled]="loading"
    ></app-cbb-button>
  </div>
</form>
